import { useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { changePasswordAPI } from "../service/AuthService";
import { Encrypt } from "../utils/constants";

const initialErrors = {
  password: "",
  confirmPassword: "",
  transactionPassword: "",
};

export default function ChangePassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [transactionPassword, setTransactionPassword] = useState("");
  const [errors, setErrors] = useState(initialErrors);
  const [submitting, setSubmitting] = useState(false);
  const userData = useSelector((state) => state.account.userData);
  const toast = useToast();

  useEffect(() => {
    toast({
      title: "Info",
      description: "Please change your password",
      status: "info",
      duration: 4000,
      isClosable: true,
    });
  }, [toast]);

  const validate = () => {
    const nextErrors = { ...initialErrors };
    if (!password) nextErrors.password = "The New Password field is required";
    else if (password.length < 5) {
      nextErrors.password = "Password must contain at least 5 characters";
    }
    if (!confirmPassword) {
      nextErrors.confirmPassword = "The Confirm Password field is required";
    } else if (password !== confirmPassword) {
      nextErrors.confirmPassword = "Password and confirm password does not match";
    }
    if (!transactionPassword) {
      nextErrors.transactionPassword = "The Transaction Code field is required";
    } else if (password === transactionPassword) {
      nextErrors.transactionPassword = "New password and transaction password cannot be same";
    }
    setErrors(nextErrors);
    return !Object.values(nextErrors).some(Boolean);
  };

  const changePassword = async (event) => {
    event.preventDefault();
    if (submitting || !validate()) return;

    setSubmitting(true);
    try {
      const data = await changePasswordAPI(
        {
          newPassword: Encrypt(password),
          password: Encrypt(transactionPassword),
          resetRequired: false,
          uid: userData.id,
        },
        userData.token
      );
      if (data?.code === 200) {
        toast({
          title: "Success",
          description: "Password changed successfully",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        window.location.href = "/tp";
        return;
      }
      toast({
        title: "Error",
        description: "Wrong Password",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } catch {
      toast({
        title: "Error",
        description: "Something went wrong",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const fieldProps = (name, value, setValue) => ({
    value,
    onChange: (event) => {
      setValue(event.target.value);
      setErrors((current) => ({ ...current, [name]: "" }));
    },
  });

  return (
    <main className="change-password-page">
      <section className="change-password-card">
        <h1>Change Password</h1>
        <form className="change-password-form" onSubmit={changePassword} noValidate>
          <PasswordField
            id="new-password"
            label="New Password"
            error={errors.password}
            {...fieldProps("password", password, setPassword)}
          />
          <PasswordField
            id="confirm-password"
            label="Confirm Password"
            error={errors.confirmPassword}
            {...fieldProps("confirmPassword", confirmPassword, setConfirmPassword)}
          />
          <PasswordField
            id="transaction-password"
            label="Transaction Password"
            error={errors.transactionPassword}
            {...fieldProps(
              "transactionPassword",
              transactionPassword,
              setTransactionPassword
            )}
          />
          <button type="submit" className="change-password-load" disabled={submitting}>
            {submitting ? "Loading..." : "Load"}
          </button>
        </form>
      </section>
    </main>
  );
}

function PasswordField({ id, label, error, value, onChange }) {
  return (
    <div className="change-password-field">
      <label htmlFor={id}>{label}</label>
      <div className="change-password-input-wrap">
        <input
          id={id}
          type="password"
          className={error ? "is-invalid" : ""}
          value={value}
          onChange={onChange}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? `${id}-error` : undefined}
        />
        {error && <span className="change-password-error-icon" aria-hidden="true">×</span>}
      </div>
      {error && <p id={`${id}-error`} className="change-password-error">{error}</p>}
    </div>
  );
}
